import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { EnrollmentData } from '../../../models/enrollment-data'

import { PortalGlobals } from '../../../../portalglobals'

@Component({
    selector: 'PhoneEnrollmentConfirmation',
    templateUrl: 'phone-enrollment-confirmation.component.html'
})
export class PhoneEnrollmentConfirmationComponent implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    confirmationNumber: string

    enrollmentJson: EnrollmentData
    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals) {
        this.enrollment = {} as EnrollmentViewModel
    }

    ngOnInit() {
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        sessionStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))
        if (this.enrollment !== undefined && this.enrollment.CONF !== undefined) {
            this.confirmationNumber = this.enrollment.CONF
        }
    }

    enrollNew(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step1'])
    }
    callStep3(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step3'])
    }
}
